import { FormattedMessage } from "react-intl";
import { Button, Heading, Skeleton, Text, tabularNumsClass } from "@lendcord/concord";
import { useGetWalletSummaryQuery } from "@/features/shared/api/walletSummary.api";

const currencyFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

function handleAddFunds() {
  // TODO: wire to the real add-funds flow once payments are integrated.
}

export function WalletCard() {
  const { data: wallet } = useGetWalletSummaryQuery();

  return (
    <div className="rounded-md bg-accent-600 p-6 text-white shadow-sm">
      <Text as="p" size="sm" className="text-white/80">
        <FormattedMessage id="lender.shared.walletBalanceTitle" />
      </Text>
      {wallet ? (
        <Heading as="p" size="lg" className={`mt-1 text-white ${tabularNumsClass}`}>
          {currencyFormatter.format(wallet.totalBalance)}
        </Heading>
      ) : (
        <Skeleton variant="text" className="mt-1 h-9 w-28 bg-white/20" />
      )}

      <div className="mt-4 rounded-sm bg-white/10 px-4 py-3">
        <Text as="p" size="xs" className="text-white/80">
          <FormattedMessage id="lender.walletCard.availableToWithdrawLabel" />
        </Text>
        {wallet ? (
          <Text as="p" size="sm" className={`mt-0.5 font-medium text-white ${tabularNumsClass}`}>
            {currencyFormatter.format(wallet.availableToWithdraw)}
          </Text>
        ) : (
          <Skeleton variant="text" className="mt-0.5 h-5 w-20 bg-white/20" />
        )}
      </div>

      <Button
        type="button"
        onClick={handleAddFunds}
        className="mt-4 w-full bg-white text-accent-600 hover:bg-white/90"
      >
        <FormattedMessage id="lender.shared.addFundsButton" />
      </Button>
    </div>
  );
}
